export default __webpack_public_path__ + "static/media/iqac-logo.9dd787cc.webp";